Auth = require 'app/scripts/db/auth'
Backbone = require 'app/scripts/lib/backbone'
ModelCache = require 'app/scripts/db/model-cache'
idToDate = require('app/common/lib/util/date').idToDate
_ = require 'underscore'

FEATURES = [
  'org-settings'
  'card-activity'
  'card-move'
  'labels-and-edit'
]

class SimplifiedStateManager
  _.extend @prototype, Backbone.Events

  @FEATURES = FEATURES

  constructor: ->
    # We want to attach a listener to the model cache after we load the current
    # logged-in user from the api, not every time we load a member.
    @subscribed = false
    ModelCache.on 'add:Member', (action) =>
      return if @subscribed || !Auth.me()?

      @listenTo ModelCache, 'add:Action', @registerAction
      @listenTo Auth.me().organizationList, 'add', @registerAction
      @listenTo Auth.me().boardList, 'add', @registerAction

      @subscribed = true

  registerAction: ->
    if @_fullViewIsUnlocked()
      if !Auth.me().isDismissed("simplified-view-full-view")
        # we use dismissals to make unlocking features persistent across sessions
        Auth.me().dismiss('simplified-view-full-view')
        @trigger 'full-view:unlocked'

      return

    for feature in FEATURES
      if !Auth.me().isDismissed("simplified-view-#{ feature }") && @isUnlocked(feature)
        Auth.me().dismiss("simplified-view-#{ feature }")
        @trigger "#{ feature }:unlocked"

  _isMemberOfMultiMemberBoard: ->
    for board in Auth.me().boardList.models
      if board.memberList.length > 1
        return true
    return false

  _hasCreatedNumCards: (threshold) ->
    count = 0
    for board in Auth.me().boardList.models
      for list in board.listList.models
        count += list.cardList.length
        return true if count >= threshold
    return false

  _fullViewIsUnlocked: ->
    # This date is about when we launched this. We don't want people who signed
    # up before that to see simplified ui, because they'll already have seen
    # the full view.
    idToDate(Auth.myId()) < new Date("2019-05-06") ||
    !Auth.isLoggedIn() ||
    Auth.me().isDismissed('simplified-view-full-view') ||
    @_hasCreatedNumCards(10) ||
    @_isMemberOfMultiMemberBoard()

  isUnlocked: (feature) ->
    return true if @_fullViewIsUnlocked() || Auth.me().isDismissed("simplified-view-#{ feature }")

    switch feature
      when 'org-settings'
        Auth.me().organizationList.length > 0
      when 'labels-and-edit'
        @_hasCreatedNumCards(5)
      when 'card-move'
        Auth.me().boardList.length > 1
      when 'card-activity'
        for action in Auth.me().getActions()
          return true if action.get('type') == 'commentCard'
        false

module.exports = new SimplifiedStateManager()
